module.exports = __webpack_public_path__ + "img/icon4.27b3fca7.png";